export default {
    user: {
        promoteUser: { method: 'post', url: 'users/{userId}/promote' },
        demoteUser: { method: 'post', url: 'users/{userId}/demote' },
        adhaarValidation: { method: 'post', url: 'users/kyc' },
        submitAdhaarOtp: { method: 'post', url: 'users/kyc' },
        pancardValidation: { method: 'post', url: 'users/kyc' },
        gstValidation: { method: 'post', url: 'users/kyc' },
        bankVerification: { method: 'post', url: 'users/kyc' },
        initailizeEsign: { method: 'post', url: 'users/kyc' },
        getSignedDocument: { method: 'post', url: 'users/kyc' }
    },
    tickets: {
        createTickets: { method: 'post', url: 'tickets' },
        closeTicket: { method: 'post', url: 'tickets/{ticketId}/close' },
        updateTicketRma: { method: 'put', url: 'tickets/{ticketId}/rma' },
        requestTrackFE: { method: 'post', url: 'tickets/requestTracking' },
        uploadBulkTickets: { method: 'post', url: 'tickets/bulk' },
        cloneTicket: { method: 'post', url: 'tickets/{ticketId}/clone' },
        notifyIsp: { method: 'post', url: 'tickets/notify/isp' },
        respondFeasibility: { method: 'post', url: 'tickets/feasibility/response' },
        ticketPayments: { method: 'get', url: 'tickets/{ticketId}/payments' },
        getRlReport: { method: 'get', url: 'tickets/rlreport' },
    },
    inventory: {
        createSites: { method: 'post', url: 'inventory/sites' },
        findAllSites: { method: 'get', url: 'inventory/sites' },
        findSiteById: { method: 'get', url: 'inventory/sites/{siteId}' },
        updateSite: { method: 'put', url: 'inventory/sites/{siteId}' },
        deleteSite: { method: 'delete', url: 'inventory/sites/{siteId}' },
        createAssets: { method: 'post', url: 'inventory/assets' },
        bulkUploadAssets: { method: 'get', url: 'inventory/assets/finance/signedUrl' },
        findAllAssets: { method: 'get', url: 'inventory/assets' },
        findAssetById: { method: 'get', url: 'inventory/assets/{assetId}' },
        updateAsset: { method: 'put', url: 'inventory/assets/{assetId}' },
        deleteAsset: { method: 'delete', url: 'inventory/assets/{assetId}' },
        migrateAsset: { method: 'post', url: 'inventory/assets/migrate' },
        releaseAsset: { method: 'post', url: 'inventory/assets/release' },
        replaceAsset: { method: 'post', url: 'inventory/assets/replace' },
        scrapAssets: { method: 'post', url: 'inventory/assets/scrap' },
        saveAssetsFinance: { method: 'post', url: 'inventory/assets/finance' },
        generateAssetBarcode: { method: 'post', url: 'inventory/assets/barcode' },
        linkReconcileAssets: { method: 'post', url: 'inventory/assets/tags/link' },
        createWarehouses: { method: 'post', url: 'inventory/warehouses' },
        findAllWarehouses: { method: 'get', url: 'inventory/warehouses' },
        findWarehouseById: { method: 'get', url: 'inventory/warehouses/{warehouseId}' },
        updateWarehouse: { method: 'put', url: 'inventory/warehouses/{warehouseId}' },
        deleteWarehouse: { method: 'delete', url: 'inventory/warehouses/{warehouseId}' },
        createSpareAssets: { method: 'post', url: 'inventory/spareassets' },
        findAllSpareAssets: { method: 'get', url: 'inventory/spareassets' },
        findSpareAssetById: { method: 'get', url: 'inventory/spareassets/{assetId}' },
        updateSpareAsset: { method: 'put', url: 'inventory/spareassets/{assetId}' },
        deleteSpareAsset: { method: 'delete', url: 'inventory/spareassets/{assetId}' },
        createSpareCategories: { method: 'post', url: 'inventory/sparecategory' },
        getSpareCategories: { method: 'get', url: 'inventory/sparecategory' },
        updateSpareCategory: { method: 'put', url: 'inventory/sparecategory/{categoryId}' },
        deleteSpareCategory: { method: 'delete', url: 'inventory/sparecategory/{categoryId}' },
        getPartcodes: { method: 'get', url: 'inventory/partcodes' },
        getAssetsFinanceHistory: { method: 'get', url: 'inventory/assets/finance/history' }
    },
    subscription: {
        getSubscriptionPlan: { method: 'get', url: 'subscription' },
    },
    admin: {
        addSupplierVendors: { method: 'post', url: 'admin/vendors' },
        getSupplierVendors: { method: 'get', url: 'admin/vendors' },
        getSupplierVendorById: { method: 'get', url: 'admin/vendors/{vendorId}' },
        updateSupplierVendor: { method: 'put', url: 'admin/vendors/{vendorId}' },
        deleteSupplierVendor: { method: 'delete', url: 'admin/vendors/{vendorId}' },
        addIssueCategories: { method: 'post', url: 'admin/issuecategories' },
        getIssueCategories: { method: 'get', url: 'admin/issuecategories' },
        getIssueCategoryById: { method: 'get', url: 'admin/issuecategories/{categoryId}' },
        updateIssueCategory: { method: 'put', url: 'admin/issuecategories/{categoryId}' },
        deleteIssueCategory: { method: 'delete', url: 'admin/issuecategories/{categoryId}' },
        addPoAssetsCategories: { method: 'post', url: 'admin/poassetcategories' },
        getPoAssetsCategories: { method: 'get', url: 'admin/poassetcategories' },
        getPoAssetCategoryById: { method: 'get', url: 'admin/poassetcategories/{categoryId}' },
        updatePoAssetCategory: { method: 'put', url: 'admin/poassetcategories/{categoryId}' },
        deletePoAssetCategory: { method: 'delete', url: 'admin/poassetcategories/{categoryId}' },
    },
    payments: {
        getPOs: { method: 'get', url: 'payments/po' },
        getPOZip: { method: 'post', url: 'payments/po/zip' }
    }
}
